import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Route, Routes } from 'react-router';
import RouteElement from '../component/Route';
import NotFound from './NotFound';
import SignIn from './SignIn';
import Dashboard from './Dashboard';
import WorkQueue from './workQueue/WorkQueue';
import Funeral from './funeral/Funeral';
import Prearrangement from './prearrangement/Prearrangement';
import Calendar from './calendar/Calendar';
import Contacts from './contacts/Contacts';
import Quotes from './quotes/Quotes';
import Enquiry from './quotes/Enquiry';
import Search from './Search';
import PhoneSearch from './PhoneSearch';
import Transfers from './transfers/Transfers';
import Music from './music/Music';
import Account from './account/Account';
import MortuaryList from './mortuary/MortuaryList';
import MortuaryItem from './mortuary/MortuaryItem';
import CheckoutList from './mortuary/Checkout/CheckoutList';
import CheckoutItem from './mortuary/Checkout/CheckoutItem';
import CoffinList from './mortuary/Coffin/CoffinList';
import DailyRunSheet2 from './reports/DailyRunSheetV2';
import CateringReport from './reports/CateringReport';
import WorkQueuePage from './workQueue2/WorkQueuePage';
import Documentation from './documentation/Documentation';
import Metrics from './metrics/Metrics';
import Snackbar from '@mui/material/Snackbar';
import BiggerMessageBar from '../component/BiggerMessageBar';
import RefereeDoctorList from './referee/RefereeDoctorList';
import { getServerLink } from '../apollo';
import { isLocalClient, isLocalServer } from '../environment';
import OnlineOrders from './arrangermanager/OnlineOrders';
import IconsPreview from './IconsPreview';
import DepositsReport from './reports/DepositsReport';
import Invoices from './financial/Invoices';
import Payments from './financial/Payments';
import Business from './financial/Financial';
import StockList from './stock/StockList';
import StockItem from './stock/StockItem';
import { PAGE_STOCK, SIGN_IN_REFERRER } from '../util/strings';
import TransfersActive from './transfers/TransfersActive';
import TransferActions from './transfers/TransfersActions';

const localLogin = isLocalClient() && !isLocalServer();

const RemoteSignIn = ({ location }) => {
    const referrer = location && location.state && location.state.referrer;
    if (referrer && referrer.pathname && referrer.pathname !== '/sign-in') {
        sessionStorage.setItem(SIGN_IN_REFERRER, referrer.pathname + (referrer.search || ''));
    }
    window.location.href = getServerLink() + '/Security/react';
    return null;
};

const Main = ({ signedIn, classes }) => (
    <main className={signedIn ? classes.main : classes.mainAnon}>
        <div className={classes.innerMain}>
            <Routes>
                {localLogin && (
                    <Route path="/sign-in" element={<RouteElement anon title={'Sign In'} component={SignIn} />} />
                )}
                {!localLogin && (
                    <Route path="/sign-in/:id/:hash/:remember?" element={<RouteElement anon component={SignIn} />} />
                )}
                {!localLogin && <Route path="/sign-in" element={<RouteElement anon component={RemoteSignIn} />} />}
                <Route path="/" element={<RouteElement auth title={'Dashboard'} component={Dashboard} />} />

                <Route
                    path="/work-queue-cards/:key?"
                    element={<RouteElement auth title={'Work Queue Cards'} component={WorkQueue} />}
                />
                <Route
                    path="/work-queue/task/:id?"
                    element={<RouteElement auth title={'Task'} component={WorkQueuePage} />}
                />
                <Route
                    path="/work-queue/:queue/:key?/:id?"
                    element={<RouteElement auth title={'Task Queue'} component={WorkQueuePage} />}
                />
                <Route
                    path="/work-queue"
                    element={<RouteElement auth title={'Task Queue'} component={WorkQueuePage} />}
                />

                <Route
                    path="/funeral/:key/:id/:tab?"
                    element={<RouteElement auth title={'Funeral'} component={Funeral} />}
                />
                <Route
                    path="/prearrangement/:key/:id/:tab?"
                    element={<RouteElement auth title={'Prearrangement'} component={Prearrangement} />}
                />
                <Route path="/search/:brand?" element={<RouteElement auth title={'Search'} component={Search} />} />
                <Route path="/phone-search" element={<RouteElement auth title={'Phone Search'} component={PhoneSearch} />} />
                <Route
                    path="/documentation/:key/:id"
                    element={<RouteElement auth title={'Documentation'} component={Documentation} />}
                />

                <Route
                    path="/calendar/:date?"
                    element={<RouteElement auth title={'Calendar'} component={Calendar} />}
                />
                <Route
                    path="/contacts/:search?"
                    element={<RouteElement auth title={'Suppliers'} component={Contacts} />}
                />
                <Route path="/music" element={<RouteElement auth title={'Music'} component={Music} />} />
                <Route path="/account" element={<RouteElement auth title={'Account Settings'} component={Account} />} />
                <Route path="/metrics" element={<RouteElement auth title={'Metrics'} component={Metrics} />} />

                <Route path="/quotes" element={<RouteElement auth title={'Enquiries'} component={Quotes} />} />
                <Route
                    path="/quotes/enquiry"
                    element={<RouteElement auth title={'New Enquiry'} component={Enquiry} />}
                />
                <Route
                    path="/quotes/enquiry/:key/:id"
                    element={<RouteElement auth title={'Enquiry'} component={Enquiry} />}
                />
                <Route
                    path="/quotes/orders"
                    element={<RouteElement auth title={'Online Orders'} component={OnlineOrders} />}
                />

                <Route
                    path="/refereedoctor"
                    element={<RouteElement auth title={'Referee Doctor'} component={RefereeDoctorList} />}
                />

                <Route
                    path="/transfers/:key/:id"
                    element={<RouteElement auth title={'Transfer Actions'} component={TransferActions} />}
                />
                <Route
                    path="/transfers/active"
                    element={<RouteElement auth title={'Body Locations'} component={TransfersActive} />}
                />
                <Route path="/transfers" element={<RouteElement auth title={'Transfers'} component={Transfers} />} />
                <Route path="/deposits" element={<RouteElement auth title={'Deposits'} component={DepositsReport} />} />

                <Route path="/financial" element={<RouteElement auth title={'Business'} component={Business} />} />
                <Route
                    path="/financial/invoices-bills"
                    element={<RouteElement auth title={'Invoices & Bills'} component={Invoices} />}
                />
                <Route
                    path="/financial/payments"
                    element={<RouteElement auth title={'Transactions'} component={Payments} />}
                />

                <Route
                    path="/catering-usage/:date?"
                    element={<RouteElement auth title={'Catering Usage'} component={CateringReport} />}
                />
                <Route
                    path="/daily-run-sheet/:date?"
                    element={<RouteElement auth title={'Run Sheet'} component={DailyRunSheet2} />}
                />

                <Route path="/mortuary" element={<RouteElement auth title={'Mortuary'} component={MortuaryList} />} />
                <Route
                    path="/mortuary/item/:key/:id"
                    element={<RouteElement auth title={'Mortuary Action'} component={MortuaryItem} />}
                />
                <Route
                    path="/mortuary/coffins"
                    element={<RouteElement auth title={'Coffins'} component={CoffinList} />}
                />
                <Route
                    path="/mortuary/checkout"
                    element={<RouteElement auth title={'Checkout'} component={CheckoutList} />}
                />
                <Route
                    path="/mortuary/checkout/:key/:id"
                    element={<RouteElement auth title={'Checkout Item'} component={CheckoutItem} />}
                />

                <Route
                    path={PAGE_STOCK}
                    element={<RouteElement auth title="Products & Services" component={StockList} />}
                />
                <Route path={PAGE_STOCK + ':id'} element={<RouteElement auth title="Item" component={StockItem} />} />
                <Route
                    path={PAGE_STOCK + ':id/:var'}
                    element={<RouteElement auth title="Variation" component={StockItem} />}
                />

                <Route
                    path="/styles/:tab?"
                    element={<RouteElement auth title={'Style Guide'} component={IconsPreview} />}
                />

                <Route path="*" element={<RouteElement title={'Page Not Found'} component={NotFound} />} />
            </Routes>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={window.appData && !!window.appData.find(o => o.newContent)}
                message={
                    <div style={{ color: 'black', margin: '-22px -26px' }}>
                        <BiggerMessageBar messageType="update">
                            <p>
                                <strong>New version ready.</strong>
                                <br />
                                We've added new features and fixed a few bugs!
                            </p>
                            <p>
                                Please save your work and reload the page.
                                <br />
                                <small>(Clear your browser cache if this message persists.)</small>
                            </p>
                        </BiggerMessageBar>
                    </div>
                }
            />

            <div className={classes.innerFoot}>&nbsp;</div>
        </div>
    </main>
);

const styles = ({ palette, spacing, sizes, funeralHome, breakpoints }) => ({
    main: {
        marginTop: sizes.headerHeight,
        flex: '1 1 auto',
        overflowY: 'auto',
        backgroundColor: 'white',
        backgroundImage: `linear-gradient(326deg, ${palette.contentForeground[funeralHome]}33 33%, ${
            palette.contentBackground[funeralHome]
        }), url("data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
    <defs>
        <filter id="texture">
            <feTurbulence type="fractalNoise" baseFrequency="0.28" numOctaves="4" stitchTiles="stitch"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.075 0"/>
        </filter>
    </defs>
    <rect width="300" height="300" fill="red" filter="url(#texture)"/>
</svg>
        `)}")`, // a bit of textured noise under some diagonal gradients
        backgroundAttachment: 'fixed, local', // move texture with scrollbar, but not gradient
        flexDirection: 'column',
        display: 'flex'
    },
    mainAnon: {
        flex: '1 1 auto',
        overflowY: 'auto',
        flexDirection: 'column',
        display: 'flex'
    },
    innerFoot: {
        // background: 'red',
        height: 24, // ensure scrolling content has a gap at the bottom.
        [breakpoints.down('sm')]: {
            height: sizes.footerHeight // safari needs bigger gap, for when interface elements appear.
        }
    },
    innerMain: {
        flex: '1 1 auto',
        padding: spacing(3),
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // safari needs for visible search results. also crops calendar viewport.
        [breakpoints.down('md')]: {
            padding: '6px 8px 12px'
        }
    }
});

export default withStyles(styles)(Main);
